













import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { groupAdd, groupUpdate } from '@/api/role'

@Component({
  name: 'GroupOperationModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() appId!: number
  @Prop() id!: number
  @Prop() name!: string
  private visible = false
  private formParams = {
    name: ''
  }

  private rules = {
    name: [{ required: true, message: '请输入角色组名', trigger: 'change' }]
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.id ? await groupUpdate({ ...this.formParams, appId: this.appId, id: this.id }) : await groupAdd({ ...this.formParams, appId: this.appId })
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      this.$nextTick(() => { this.formParams.name = this.name })
    }
  }
}
